// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1951":"f427140c","2768":"36872c62","3124":"19b07695","3244":"52621be5","3936":"e1e36bfc"}[chunkId] + ".chunk.css";
};